import React, { useState } from "react";
import styles from "./ContactM.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { openPrivacyPolicy } from "../../utils/cookieEvents";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    privacy: false
  });

  const [errors, setErrors] = useState({});

  // 🔍 Funkcja walidująca pojedyncze pole
  const validateField = (name, value, type) => {
    let error = "";

    const nameRegex = /^[A-Za-zĄąĆćĘęŁłŃńÓóŚśŹźŻż]{2,15}\s[A-Za-zĄąĆćĘęŁłŃńÓóŚśŹźŻż]{3,32}(?:[-\s][A-Za-zĄąĆćĘęŁłŃńÓóŚśŹźŻż]{3,32})?$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const phoneRegex = /^(\+48)?\s?(\d{3}[\s-]?){2}\d{3}$/;
    const messageRegex = /^[A-Za-z0-9ĄąĆćĘęŁłŃńÓóŚśŹźŻż.,!?"'()\-_\s]{10,1000}$/;

    switch (name) {
      case "name":
        if (!value.trim()) {
          error = "Podaj imię i nazwisko.";
        } else if (!nameRegex.test(value)) {
          error = "Wpisz imię i nazwisko w prawidłowym formacie.";
        }
        break;

      case "email":
        if (!value.trim()) {
          error = "Podaj adres e-mail.";
        } else if (!emailRegex.test(value)) {
          error = "Nieprawidłowy format adresu e-mail.";
        }
        break;

      case "phone":
        if (!value.trim()) {
          error = "Podaj numer telefonu.";
        } else if (!phoneRegex.test(value)) {
          error = "Wpisz numer telefonu w prawidłowym formacie.";
        }
        break;

      case "message":
        if (!value.trim()) {
          error = "Wpisz treść wiadomości.";
        } else if (!messageRegex.test(value)) {
          error = "Wpisz treść wiadomości w prawidłowym formacie.";
        }
        break;

      default:
        break;
    }

    return error;
  };

  const [banner, setBanner] = useState({
    show: false,
    message: "",
    type: "" // "success" | "error"
  });

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    // aktualizujemy dane
    setFormData(prev => ({ ...prev, [name]: newValue }));

    // walidujemy konkretne pole
    const fieldError = validateField(name, newValue, type);

    // aktualizujemy błędy – tylko dla danego pola
    setErrors(prev => ({ ...prev, [name]: fieldError }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    // Walidacja wszystkich pól
    const newErrors = {};
    Object.entries(formData).forEach(([key, value]) => {
      const fieldError = validateField(key, value);
      if (fieldError) newErrors[key] = fieldError;
    });
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    // 🔹 Konwersja checkboxa privacy na "TAK"/"NIE"
    const emailData = {
      ...formData,
      privacy: formData.privacy ? "TAK" : "NIE"
    };

    try {
      const result = await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID_MECHANIC,
        emailData,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      ); // używamy emailData zamiast formData

      if (result.status === 200) {
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
          privacy: false
        });
        setErrors({});
        setBanner({
          show: true,
          message: "Wiadomość wysłana!",
          type: "success"
        });
        setTimeout(
          () =>
            setBanner({
              show: false,
              message: "",
              type: ""
            }),
          4000
        );
      } else {
        setBanner({
          show: true,
          message: "Nie udało się wysłać wiadomości.",
          type: "error"
        });
        setTimeout(
          () =>
            setBanner({
              show: false,
              message: "",
              type: ""
            }),
          4000
        );
      }
    } catch (error) {
      console.error("Błąd wysyłki:", error);
      setBanner({
        show: true,
        message: "Błąd wysyłki. Spróbuj ponownie.",
        type: "error"
      });
      setTimeout(
        () =>
          setBanner({
            show: false,
            message: "",
            type: ""
          }),
        4000
      );
    }
  };

  return <div className="darkSectionContent" id="contact">
      <div className="lightSectionTitle">
        <h1>Skontaktuj się z nami</h1>
      </div>
      <div className={styles.contactModule}>
        <div className={styles.sectionDescription}>
          <address className={styles.contactElements}>
            <h5 className={styles.title}>Dane kontaktowe</h5>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`${styles.contactImage} lucide lucide-smartphone-icon lucide-smartphone`}>
                <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
                <path d="M12 18h.01" />
              </svg>
              <span className={styles.contactItem}> Telefon: </span>
              <span className={styles.contactValue}>xxx xxx xxx</span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`${styles.contactImage} lucide lucide-mail-icon lucide-mail`}>
                <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
                <rect x="2" y="4" width="20" height="16" rx="2" />
              </svg>
              <span className={styles.contactItem}> Email: </span>
              <span className={styles.contactValue}>
                e-mail firmy
              </span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`${styles.contactImage} lucide lucide-house-icon lucide-house`}>
                <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
                <path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              </svg>
              <span className={styles.contactItem}> Adres: </span>
              <span className={styles.contactValue}>
                adres firmy
              </span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`${styles.contactImage} lucide lucide-building2-icon lucide-building-2`}>
                <path d="M10 12h4" />
                <path d="M10 8h4" />
                <path d="M14 21v-3a2 2 0 0 0-4 0v3" />
                <path d="M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2" />
                <path d="M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" />
              </svg>
              <span className={styles.contactItem}> NIP: </span>
              <span className={styles.contactValue}>nip firmy</span>
            </div>
          </address>
          <div className={styles.iconGroup}>
            <a href="/#" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faFacebookF} className={styles.icon} />
            </a>
            <a href="/#" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} className={styles.icon} />
            </a>
          </div>
        </div>

        {banner.show && <div className={`${styles.toastTop} ${banner.type === "success" ? styles.toastSuccess : styles.toastError}`}>
            <span className={styles.toastIcon}>
              {banner.type === "success" ? "✔️" : "❌"}
            </span>
            <span>
              {banner.message}
            </span>
          </div>}

        {/* 🔹 Jeśli są błędy walidacji */}
        {Object.keys(errors).length > 0 && <div className={`${styles.toastTop} ${styles.toastError}`}>
            <span className={styles.toastIcon}>⚠️</span>
            <span>Uzupełnij poprawnie wszystkie wymagane pola.</span>
          </div>}

        <form className={styles.contactForm} onSubmit={handleSubmit}>
          <div className={styles.titleOfForm}>
            <h5>Skontaktuj się z nami</h5>
          </div>
          {/* Imię i nazwisko */}
          <div className={styles.formGroup}>
            <input type="text" id="name" name="name" placeholder="Imię i nazwisko" value={formData.name} onChange={handleChange} className={styles.formValue} />
            {errors.name && <div className={styles.fieldToast}>
                <span className={styles.fieldToastIcon}>⚠️</span>
                {errors.name}
              </div>}
          </div>

          {/* Email */}
          <div className={styles.formGroup}>
            <input type="text" id="email" name="email" placeholder="E-mail" value={formData.email} onChange={handleChange} className={styles.formValue} />
            {errors.email && <div className={styles.fieldToast}>
                <span className={styles.fieldToastIcon}>⚠️</span>
                {errors.email}
              </div>}
          </div>

          {/* Telefon */}
          <div className={styles.formGroup}>
            <input type="text" id="phone" name="phone" placeholder="Telefon" value={formData.phone} onChange={handleChange} className={styles.formValue} />
            {errors.phone && <div className={styles.fieldToast}>
                <span className={styles.fieldToastIcon}>⚠️</span>
                {errors.phone}
              </div>}
          </div>

          {/* Wiadomość */}
          <div className={styles.formGroup}>
            <textarea id="message" name="message" placeholder="Treść wiadomości" value={formData.message} onChange={handleChange} className={`${styles.formValue} ${styles.messageValue}`} />
            {errors.message && <div className={styles.fieldToast}>
                <span className={styles.fieldToastIcon}>⚠️</span>
                {errors.message}
              </div>}
          </div>

          <div className={styles.formGroup}>
            <p className={styles.privacyInfo}>
              Administratorem Państwa danych jest <strong>Nazwa firmy</strong>. Dane przetwarzane są w celu obsługi Państwa zapytania. Więcej informacji znajdziesz w
              <button id="policyPrivacy" type="button" className={styles.btnChangeSettings} onClick={openPrivacyPolicy}>
                Polityka prywatności
              </button>
            </p>
          </div>

          {/* Zgoda marketingowa – NIEOBOWIĄZKOWA */}
          <div className={styles.formGroup}>
            <label htmlFor="privacy" className={styles.labelsPrivacy}>
              <input type="checkbox" id="privacy" name="privacy" checked={formData.privacy} onChange={handleChange} className={styles.privacy} />
              <span className={styles.customCheckbox} />
              Wyrażam zgodę na przetwarzanie moich danych osobowych przez
              <strong>
                {" "}Nazwa firmy
              </strong> w celu przedstawienia oferty handlowej, zgodnie z
              <button id="policyPrivacyCheck" type="button" className={styles.btnChangeSettings} onClick={openPrivacyPolicy}>
                Polityką prywatności
              </button>
            </label>
          </div>
          <div className={styles.buttonElementInForm}>
            <button type="submit" className={styles.formButton}>
              Wyślij
            </button>
          </div>
        </form>
      </div>
    </div>;
};

export default ContactForm;
